import { Navigate, useParams } from 'react-router-dom';
import { SETTINGS_PATH } from '@/config/settingsRegistry';

const LEGACY_CATEGORY_REDIRECTS: Record<string, string> = {
  security: 'organization',
  system: 'organization',
  localization: 'organization',
};

/** Category hub removed — masters are listed on the settings page under each category heading. */
export function SettingsCategoryPage() {
  const { categoryKey } = useParams();
  const targetKey = categoryKey ? (LEGACY_CATEGORY_REDIRECTS[categoryKey] ?? categoryKey) : '';
  const hash = targetKey ? `#${targetKey}` : '';
  return <Navigate to={`${SETTINGS_PATH}${hash}`} replace />;
}
